import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { EncodingUtils } from '../../common/encoding-utils';
import { ActionConfigDTO } from '../../system/system-dtos';
import { EnvironmentService } from '../../common/services/env-configuration/environment.service';

@Injectable()
export class ActionService {
  constructor(private envService: EnvironmentService) {}

  public determineIsDisabled(data: any, editCondition: string) {
    const nodeDetails = this.envService.getNodeInfo();
    const header = data;
    return editCondition && !eval(editCondition);
  }

  public determineHasWarning(data: any, warningCondition: string) {
    const nodeDetails = this.envService.getNodeInfo();
    const header = data;
    return warningCondition && eval(warningCondition);
  }

  public static actionRequest(
    params: Params,
    entityId: any,
    action: ActionConfigDTO,
    formData: any,
    url: string,
    http: HttpClient,
    toastrService: ToastrService
  ): Observable<Object> {
    if (action.url.includes('/upload')) {
      action.multipartForm = true;
    }

    if (action.multipartForm) {
      let file: File;
      let fieldName: string;
      let data: any;

      Object.keys(formData).forEach((key) => {
        let isAset: boolean = false;

        if (formData[key] instanceof Set) {
          isAset = true;
          fieldName = key;
          const files: Set<File> = formData[key];
          if (files.size > 0) {
            files.forEach((f) => {
              file = f;
            });
          }
        }
      });
      data = formData; // ctrls.getRawValue();
      if (file !== undefined) {
        data[fieldName] = file.name;

        const formData: FormData = new FormData();

        formData.append(fieldName, file, file.name);
        formData.append('data', JSON.stringify(EncodingUtils.encodeRequest(data)));
        let headers = new HttpHeaders();
        // we add content type so encoding-interceptor can identify and not encode, we also delete header
        headers = headers.append('Content-Type', 'multipart/form-data');
        return http.post(url, formData, { headers });
      }
      toastrService.error('no file to upload');
      return EMPTY;
    }
    if (action.downloadAction) {
      return http.request(action.method, url, {
        body: Object.keys(formData).length > 0 ? formData : 0,
        responseType: url.endsWith('csv') ? 'text' : 'arraybuffer',
        observe: 'response',
      });
    }

    return http.request(action.method, url, { body: Object.keys(formData).length > 0 ? formData : 0 });
  }
}
